// Runtime-API polyfills for old browsers (#975) — must run before any app code
// so shims (Object.hasOwn, CanvasRenderingContext2D.roundRect) are in place
// before Safari < 16.4 hits the crashing code paths.
import "./polyfills";

import React from "react";
import ReactDOM from "react-dom/client";
import "./globals.css";
import { decideBootElement } from "./bootGuard";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Toaster } from "@primitives/toaster";
import "./config/i18n";

import { QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./queryClient";
import { checkAndRequestPersistentStorage } from "./lib/storage";
import { ErrorBoundary, ErrorFallback } from "./components/error-boundary";
import { initErrorReporting } from "./config/errorReporting";

// Register the app-state context provider, capture async errors and unhandled
// rejections (which never reach the React boundary), and flush any reports
// queued offline in a previous session.
initErrorReporting();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ErrorBoundary
          scope="root"
          fallback={(props) => <ErrorFallback {...props} />}
        >
          {/*
           * Boot guard (#943): render the app only when WebAssembly is available;
           * otherwise show a friendly unsupported-environment screen instead of an
           * opaque crash.
           */}
          {decideBootElement()}
          <Toaster />
        </ErrorBoundary>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

serviceWorkerRegistration.register();
// Fire-and-forget; the helper is internally guarded, but defend the call site
// too so a future regression can never surface as an unhandled rejection.
void checkAndRequestPersistentStorage().catch(() => {});
